export const sceneStars = `
    vec3 sceneStars(vec2 uv, float time) {
        const float tmax = 10.0;
        float nt = mod(time, tmax * 2.0);
        if (nt > tmax) {
          nt = tmax * 2.0 - nt;
        }
        uv.x += nt * 0.02; vec3 col=vec3(0.);
        for(float i=0.; i<1.; i+=0.2) { 
            float d=fract(i+nt*0.05); float s=mix(20.,0.5,d);
            vec2 st=uv*s+vec2(i*15.3,i*43.2);
            if(fract(sin(dot(floor(st),vec2(12.9,78.2)))*43758.5)>0.98) col+=vec3(d*smoothstep(1.,0.9,d));
        }
        return col;
    }
`;
